const apiKey = process.env.REACT_APP_TMDB_API_KEY || "";

if (!apiKey && process.env.NODE_ENV !== "test") {
  console.error(
    "Falta REACT_APP_TMDB_API_KEY. Copiá .env.example a .env y completá tu API key de TMDB."
  );
}

export const TMDB_CONFIG = {
  baseUrl: "https://api.themoviedb.org/3",
  imageBaseUrl: "https://image.tmdb.org/t/p/original",
  apiKey,
};
